module.exports = __webpack_public_path__ + "img/Prompt Engineering.9ab72c85.png";